import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ToastProvider } from './contexts/ToastContext';
import { YearProvider } from './contexts/YearContext';
import ProtectedRoute from './routes/ProtectedRoute';
import Layout from './components/Layout';
import ScrollToTop from './components/ScrollToTop';
import ErrorBoundary from './components/ErrorBoundary';
import LoginPage from './pages/LoginPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import ForcedPasswordChangePage from './pages/ForcedPasswordChangePage';
import Home from './pages/Home';
import TempsPage from './pages/TempsPage';
import TMPPage from './pages/TMPPage';
import FacturationPage from './pages/FacturationPage';
import ChargesPage from './pages/ChargesPage';
import PLPage from './pages/PLPage';
import AdminPage from './pages/AdminPage';
import ScanReceiptPage from './pages/ScanReceiptPage';
import BankingPage from './pages/BankingPage';
import SentryTest from './components/SentryTest';

function App() {
  return (
    <ErrorBoundary>
      <Router>
        <AuthProvider>
          <ToastProvider>
            <YearProvider>
              <ScrollToTop />
        <Routes>
          {/* Routes publiques */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="/forced-password-change" element={<ForcedPasswordChangePage />} />

          {/* Route de test Sentry - À SUPPRIMER après vérification */}
          <Route path="/sentry-test" element={<SentryTest />} />

          {/* Routes protégées : nécessitent une authentification */}
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Layout>
                  <Home />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/temps"
            element={
              <ProtectedRoute>
                <Layout>
                  <TempsPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/tmp"
            element={
              <ProtectedRoute>
                <Layout>
                  <TMPPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/facturation"
            element={
              <ProtectedRoute>
                <Layout>
                  <FacturationPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/charges"
            element={
              <ProtectedRoute>
                <Layout>
                  <ChargesPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/pl"
            element={
              <ProtectedRoute>
                <Layout>
                  <PLPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin"
            element={
              <ProtectedRoute requiredRole="super_admin">
                <Layout>
                  <AdminPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/scan"
            element={
              <ProtectedRoute>
                <Layout>
                  <ScanReceiptPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/banking"
            element={
              <ProtectedRoute>
                <Layout>
                  <BankingPage />
                </Layout>
              </ProtectedRoute>
            }
          />
        </Routes>
            </YearProvider>
          </ToastProvider>
        </AuthProvider>
      </Router>
    </ErrorBoundary>
  );
}

export default App;